export interface OsmosisErrorResponse {
  statusCode: number;
  message: string;
  errorInfo: string;
  detailedStatusCode: OsmosisExceptionCode;
}

export enum OsmosisExceptionCode {
  GenericException = 5000,
  AlreadyExists,
  MpnIdDomainMismatch
}
